// Toggle Modal
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

/////////////////////
// Authentication //
///////////////////

//Get current user from token in localStorage
export const ME_FROM_TOKEN = 'ME_FROM_TOKEN';
export const ME_FROM_TOKEN_SUCCESS = 'ME_FROM_TOKEN_SUCCESS';
export const ME_FROM_TOKEN_FAILURE = 'ME_FROM_TOKEN_FAILURE';
export const RESET_TOKEN = 'RESET_TOKEN';

// Login
export const LOGIN_PENDING = 'LOGIN_PENDING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

// Logout
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

// Signup
export const SIGNUP_PENDING = 'SIGNUP_PENDING';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_ERROR = 'SIGNUP_ERROR';

// Validate userame
export const VALIDATE_USERNAME_PENDING = 'VALIDATE_USERNAME_PENDING';
export const VALIDATE_USERNAME_SUCCESS = 'VALIDATE_USERNAME_SUCCESS';
export const VALIDATE_USERNAME_ERROR = 'VALIDATE_USERNAME_ERROR';

// User Data
export const RELOAD_USER_DATA = 'RELOAD_USER_DATA';
export const RESET_USER_DATA = 'RESET_USER_DATA';
// export const RELOAD_FRIENDS = 'RELOAD_FRIENDS';

export const SET_UPDATE_USER_PENDING = 'SET_UPDATE_USER_PENDING';
export const SET_UPDATE_USER_SUCCESS = 'SET_UPDATE_USER_SUCCESS';
export const SET_UPDATE_USER_ERROR = 'SET_UPDATE_USER_ERROR';

// Add Email
export const SET_ADD_EMAIL_PENDING = 'SET_ADD_EMAIL_PENDING';
export const SET_ADD_EMAIL_SUCCESS = 'SET_ADD_EMAIL_SUCCESS';
export const SET_ADD_EMAIL_ERROR = 'SET_ADD_EMAIL_ERROR';










// WEBPACK FOOTER //
// ./src/store/constants/ActionTypes.js